export const WEB_BFF_MESSAGE_CENTRE_BASE_URL = 'bff-api/message-centre';
export const GET_CONVERSATIONS_URL = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/conversations`;
export const GET_PAGINATED_CONVERSATIONS_URL = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/conversations/extended`;
export const GET_SINGLE_CONVERSATION = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/conversation`;
export const POST_MESSAGE = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/message`;
export const STREAM_TOKEN = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/streamToken`;

/** mark-as-read */
export const MESSAGES = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/messages`;
export const MARK_AS_READ = 'mark-as-read';

/** block/unblock/mute */
export const BLOCK_USER = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/users/block`;
export const UNBLOCK_USER = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/users/unblock`;
export const DELETE_CONVERSATION = `${WEB_BFF_MESSAGE_CENTRE_BASE_URL}/delete-conversation`;

/** report user */
export const WEB_BFF_REPORT_USER_BASE_URL = 'bff-api/report';
export const REPORT_USER = `${WEB_BFF_REPORT_USER_BASE_URL}/report-user`;
export const CAN_REPORT_USER = `${WEB_BFF_REPORT_USER_BASE_URL}/can-report-user`;

/** review user */
export const WEB_BFF_REVIEW_USER_BASE_URL = 'bff-api/reviews';
export const GET_RATING = `${WEB_BFF_REVIEW_USER_BASE_URL}/rating-received`;
export const POST_REVIEW = `${WEB_BFF_REVIEW_USER_BASE_URL}/reviews`;
export const CAN_REVIEW = `${WEB_BFF_REVIEW_USER_BASE_URL}/reviewer/can-review`;
export const BRAZE_NOTIFICATION = `${WEB_BFF_REVIEW_USER_BASE_URL}/braze/notification`;
